import { useEffect } from 'react';
import { apiHolder } from 'api';
import { useObservable } from 'rxjs-hooks';
import { map, first } from 'rxjs/operators';
import lodashGet from 'lodash/get';
import { iif } from 'rxjs';
const nimApi = apiHolder.api.requireLogicalApi('NIM');
export function useYunxinAccount(ids, scene = 'p2p', noLiveUpdate = false) {
    useEffect(() => {
        if (scene !== 'p2p') {
            return;
        }
        nimApi.imusers.requestUser(ids);
    }, [ids]);
    return useObservable((_, $props) => {
        const $id = $props.pipe(map(([id]) => id));
        const $user = nimApi.imusers.getUserById($id);
        return iif(() => {
            return noLiveUpdate;
        }, $user.pipe(first(user => {
            return lodashGet(user, 'nick.length', 0) !== 0;
        })), $user);
    }, {}, [ids]);
}
export const useYunxinAccounts = (ids) => {
    useEffect(() => {
        ids
            .filter(item => item.length)
            .forEach(item => {
            nimApi.imusers.requestUser(item);
        });
    }, [ids.join('-')]);
    return useObservable((_, $props) => {
        const $ids = $props.pipe(map(([idlist]) => idlist));
        return nimApi.imusers.getUsersByIds($ids);
    }, {}, [ids]);
};
